import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { ConfigContext } from "../context/GlobalContext";
import { Languages } from "../Utils/Languages";

const ExpensView = () => {
    const { state } = useContext(ConfigContext);
    const navigate = useNavigate();
    const expense_data = state?.SELECTEDEXPENSE;

    return (
        <div className="card shadow-lg p-4 w-80 mt-20 position-relative">
            <div className="card  p-4 w-100 max-w-800 position-relative">
                <div className="card-header">
                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-2">
                        <div className="d-flex align-items-center gap-2">
                            <button onClick={() => navigate(-1)} className="btn">
                                <i className="fa fa-arrow-left" style={{ fontSize: 18 }}></i>
                            </button>
                            <p className='fw-semibold mb-0 fs-5'>{Languages[state?.LANGUAGE].expense_view}</p>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <div className="container">
                        <div className="row g-3">
                            <div className="col-12 col-md-6">
                                <span className="fw-medium text-primary-light">{Languages[state?.LANGUAGE].name}</span>
                                <span className="text-secondary-light">: {expense_data?.expenseName}</span>
                            </div>
                            <div className="col-12 col-md-6">
                                <span className="fw-medium text-primary-light">{Languages[state?.LANGUAGE]?.Expense_Category}</span>
                                <span className="text-secondary-light">: {expense_data?.expenseCategory}</span>
                            </div>
                            <div className="col-12 col-md-6">
                                <span className="fw-medium text-primary-light">{Languages[state?.LANGUAGE]?.amount}</span>
                                <span className="text-secondary-light">: {expense_data?.amount}</span>
                            </div>
                            <div className="col-12 col-md-6">
                                <span className="fw-medium text-primary-light">{Languages[state?.LANGUAGE]?.Payment_Method}</span>
                                <span className="text-secondary-light">: {expense_data?.paymentMethod}</span>
                            </div>
                            <div className="col-12">
                                <span className="fw-medium text-primary-light">{Languages[state?.LANGUAGE]?.description}</span>
                                <span className="text-secondary-light">: {expense_data?.expenseDescription}</span>
                            </div>
                            {/* <div className="col-12">
                                <span className="fw-medium text-primary-light">Company ID</span>
                                <span className="text-secondary-light">: {expense_data?.companyId}</span>
                            </div> */}
                            <div className="col-12">
                                <span className="fw-medium text-primary-light">{Languages[state?.LANGUAGE]?.issued_date}</span>
                                <span className="text-secondary-light">: {expense_data?.expenseDate ? new Date(parseInt(expense_data.expenseDate)).toLocaleDateString() : "Invalid date"}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="align-self-end m-3">
                        <button
                          type="reset"
                          onClick={() => {
                            navigate(-1);
                          }}
                          className="border btn-sm border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-40 py-6 radius-8"
                        >
                          {Languages[state?.LANGUAGE].back}
                        </button>
                      </div>
            </div>
        </div>
    );
};

export default ExpensView;